import clsx from 'clsx';
import React from 'react'

interface ShowPendingInfoProps {
  classes?: string;
  message?: string;
}
const ShowPendingInfo = ({ classes, message }: ShowPendingInfoProps) => {
  return (
    <span className={clsx(`italic text-gray-400 text-xs`, classes)}>{message || 'Pending info'}</span>
  )
}

export default ShowPendingInfo